import React, { Fragment, useEffect } from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addBreadcrumb, resetBreadcrumb, truncateBreadcrumb } from "../../context/reducers/breadcrump"; // Assuming it's in store folder
import { platformLayout } from "../../utils/constants";

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const breadcrumbPaths = useSelector((state) => state?.breadcrumb?.breadcrumbPaths); // Get breadcrumb history from Redux
  let role = localStorage.getItem("userRole");

  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const homePath = role === platformLayout.Platform ? "super-admin/home" : "app/home";

  useEffect(() => {
    const currentPath = pathnames.join("/");
    if (
      currentPath !== "" &&
      !breadcrumbPaths?.some((b) => b.path === currentPath) &&
      currentPath !== homePath // Prevent adding Home again
    ) {
      dispatch(
        addBreadcrumb({
          path: currentPath,
          state: location.state || null
        })
      );
    }

    // Replace reset with truncate
    const foundIndex = breadcrumbPaths.findIndex((b) => b.path === currentPath);
    if (foundIndex !== -1 && foundIndex < breadcrumbPaths.length - 1) {
      dispatch(truncateBreadcrumb(currentPath));
    }
  }, [location.pathname, dispatch, breadcrumbPaths, pathnames, location.state, homePath]);

  useEffect(() => {
    const currentPath = pathnames.join("/");
    // If current path is home, we reset
    if (currentPath === homePath) {
      dispatch(resetBreadcrumb());
      return;
    }
    const existing = breadcrumbPaths.find((b) => b.path === currentPath);
    // Add current path if it's not in the breadcrumb list
    if (!existing && currentPath !== "") {
      dispatch(
        addBreadcrumb({
          path: currentPath,
          state: location.state || null
        })
      );
    }
    // Truncate breadcrumb if going back in history
    const foundIndex = breadcrumbPaths.findIndex((b) => b.path === currentPath);
    if (foundIndex !== -1 && foundIndex < breadcrumbPaths.length - 1) {
      dispatch(truncateBreadcrumb(currentPath));
    }
  }, [location.key]); // 👈 key changes on every navigation

  // Handle Home click to reset the breadcrumb history
  const handleHomeClick = () => {
    dispatch(resetBreadcrumb()); // Reset breadcrumb history on Home click
    navigate(`/${homePath}`);
  };

  // **Remove duplicate "Home" from breadcrumbs**
  const filteredBreadcrumbs = breadcrumbPaths?.filter(
    (item) => item.path !== homePath
  );

  return (
    <Fragment>
      {!pathnames.includes("home") && (
        <Breadcrumb listTag="div">
          {/* Home link that resets breadcrumb history */}
          <BreadcrumbItem>
            <span
              onClick={handleHomeClick}
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            >
              Home
            </span>
          </BreadcrumbItem>
          {filteredBreadcrumbs?.map((item, index) => {
            const routeTo = `/${item.path}`;
            const pathName = item.path.split("/").pop();
            const isLast = index === filteredBreadcrumbs.length - 1;

            return (
              <BreadcrumbItem key={index}>
                <span
                  onClick={() => navigate(routeTo, { state: item.state })}
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "underline",
                    fontWeight: isLast ? "bold" : "normal"
                  }}
                >
                  {pathName.charAt(0).toUpperCase() + pathName.slice(1)}
                </span>
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      )}
    </Fragment>
  );
};

export default Breadcrumbs;

